import { api } from "./client";

export const MaintenanceAPI = {
  dashboard: () => api.get("/maintenance/dashboard"),
  history: () => api.get("/maintenance/history"),
  createSchedule: (payload) => api.post("/maintenance/schedules", payload),
  updateSchedule: (id, payload) => api.patch(`/maintenance/schedules/${id}`, payload),
  completeSchedule: (id, payload) => api.post(`/maintenance/schedules/${id}/complete`, payload),
  reopenSchedule: (id, payload) => api.post(`/maintenance/schedules/${id}/reopen`, payload),
  sendReminders: () => api.post("/maintenance/reminders/send"),
  uploadReports: (id, files) => {
    const formData = new FormData();
    (Array.isArray(files) ? files : []).forEach((file) => formData.append("files", file));
    return api.post(`/maintenance/schedules/${id}/reports`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  uploadInvoices: (id, { files, invoiceNumber, invoiceAmount, invoiceDate }) => {
    const formData = new FormData();
    Array.from(files || []).forEach((file) => formData.append("files", file));
    if (invoiceNumber) formData.append("invoice_number", invoiceNumber);
    if (invoiceAmount !== "" && invoiceAmount != null) formData.append("invoice_amount", invoiceAmount);
    if (invoiceDate) formData.append("invoice_date", invoiceDate);
    return api.post(`/maintenance/schedules/${id}/invoices`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
